import AdminHeaderLogoIcon from 'components/icons/AdminHeaderLogoIcon';
import ExternalUserHeaderLogoIcon from 'components/icons/ExternalUserHeaderLogoIcon';
import { LASTA_DOMAIN } from 'config';
import { USER_HEADER } from 'utils/constants';

export const getInfoByDomain = () => {
    const host = window.location.hostname;
    const isLastaDomain = host === LASTA_DOMAIN;
    return {
        logo: isLastaDomain ? AdminHeaderLogoIcon : ExternalUserHeaderLogoIcon,
        text: isLastaDomain ? USER_HEADER.ADMIN : USER_HEADER.EXTERNAL_USER,
    };
};
